import React, { useState, useLayoutEffect, useRef } from "react"
import Img from "gatsby-image"
import {
  Box,
  CircularProgress,
  IconButton,
  withWidth,
  makeStyles
} from "@material-ui/core"
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons"
import Carousel from "react-multi-carousel"

import "react-multi-carousel/lib/styles.css"

let nameStyles = {
  position: "absolute",
  left: 24,
  bottom: 24,
  maxWidth: "70%",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  lineHeight: "18px",
  fontSize: 14,
  fontFamily: "MabryProBold",
  fontWeight: "bold",
  color: "white",
}

const useStyles = makeStyles(theme => ({
  arrow: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    borderRadius: "50%",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      color: "#fff",
    },
    transition: "all 0.3s ease",
  },
}))


const ImageSliderWithTextWrapped = ({
  data,
  loading,
  width,
  sliderImagesTitles,
}) => {
  const [current, setCurrent] = useState(1)
  // eslint-disable-next-line no-unused-vars
  const [direction, setdirection] = useState("left")
  // eslint-disable-next-line no-unused-vars
  const [trigger, settrigger] = useState(true)
  const isSmall = width === "xs" || width === "sm"
  let carouselRef = useRef(null)
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  }

  const classes = useStyles()

  useLayoutEffect(() => {
    settrigger(true)
  }, [current])

  return loading ? (
    <CircularProgress size={60} />
  ) : data && data.length > 0 ? (
    <Box position="relative" style={{ margin: "0 auto" }}>
      {/* <MySlidingImage
        img={data?.[current]?.fluid?.src || data[current].src || data[current]}
        direction={direction}
        trig={trigger}
        width={width}
      /> */}
      <Carousel
        arrows={false}
        ref={ref => (carouselRef = ref)}
        responsive={responsive}
        style={{ display: "grid" }}
      >
        {data.map(image => {
          return (
            <div
              key={image.title}
              style={{
                display: "grid",
                gridTemplateRows: isSmall ? "193px" : "480px",
              }}
            >
              <Img
                loading="eager"
                fluid={image?.fluid}
                style={{ borderRadius: "2px" }}
              />
            </div>
          )
        })}
      </Carousel>

      <Box style={nameStyles}>
        {/* {data[current].text || data[current].title} */}
        {sliderImagesTitles?.[current - 1]}
        <br />
        <span
          style={{
            fontFamily: "MabryProLight",
          }}
        >
          Photo {current}/{data.length}
        </span>
      </Box>
      <Box display="flex" position="absolute" right={24} bottom={24}>
        <IconButton
          style={{ marginRight: 8, backgroundColor: "white" }}
          size="small"
          onClick={() => {
            carouselRef.previous()
            setCurrent(current => {
              if (current > 1) {
                return current - 1
              } else {
                return current
              }
            })
            settrigger(false)
            setdirection("right")
          }}
        >
          <div className={classes.arrow}>
            <KeyboardArrowLeft />
          </div>
        </IconButton>
        <IconButton
          size="small"
          style={{ backgroundColor: "white" }}
          onClick={() => {
            carouselRef.next()
            setCurrent(current => {
              if (current < data?.length) {
                return current + 1
              } else {
                return current
              }
            })
            settrigger(false)
            setdirection("left")
          }}
        >
          <div className={classes.arrow}>
            <KeyboardArrowRight />
          </div>
        </IconButton>
      </Box>
    </Box>
  ) : (
    <div />
  )
}

export const ImageSliderWithText = withWidth()(ImageSliderWithTextWrapped)
